var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 157,
    viewBox: "0 0 145 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddd_714_1119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.189 52.2353C136.189 84.6901 109.731 111 77.0943 111C44.4574 111 18 84.6901 18 52.2353C18 19.7804 62.026 3 94.6629 3C127.3 3 136.189 19.7804 136.189 52.2353Z",
    fill: "#F9EEEE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.7368 40C73.6862 40 65.5457 42.054 65.5457 44.5885C65.5457 44.6996 65.555 44.8081 65.597 44.9192C69.4227 44.935 72.939 46.3626 75.6278 48.7119C78.0748 49.0294 80.8269 49.1976 83.7368 49.1976C93.7874 49.1976 101.938 47.1229 101.938 44.5885C101.938 42.054 93.782 40 83.7368 40ZM65.5457 46.769C58.0788 46.769 52 52.8762 52 60.3897C52 67.8979 58.0736 74 65.5457 74C73.0178 74 79.1017 67.8979 79.1017 60.3897C79.1017 52.8762 73.0178 46.769 65.5457 46.769ZM102 47.2237C101.99 49.7582 93.8388 51.8225 83.7883 51.8225C81.8361 51.8225 79.9498 51.7483 78.1871 51.6055C78.9974 52.7695 79.6664 54.0583 80.1294 55.4498C81.5081 55.508 82.7569 55.5222 83.7883 55.5222C88.3346 55.5222 97.064 55.1365 102 52.4116V47.2237ZM65.5457 48.6085C72.0022 48.6085 77.2517 53.8921 77.2517 60.3897C77.2517 66.882 72.0022 72.1605 65.5457 72.1605C59.0891 72.1605 53.8396 66.882 53.8396 60.3897C53.8396 53.8921 59.0891 48.6085 65.5457 48.6085ZM64.1787 51.4918V53.6104C61.8056 54.0548 60.4275 55.5996 60.4275 57.5891C60.4275 59.7532 62.0522 60.8722 64.4255 61.6712C66.0935 62.2268 66.7996 62.7674 66.7996 63.614C66.7996 64.487 65.9354 64.9988 64.6515 64.9988C63.2097 64.9988 61.8986 64.5303 60.9619 64.017L60.2939 66.6317C61.141 67.1026 62.5869 67.524 64.076 67.5927V69.7113H66.2754V67.4067C68.8275 66.9834 70.2014 65.2935 70.2014 63.304C70.1954 61.2774 69.1534 60.0501 66.5118 59.1082C64.6016 58.4151 63.8294 57.9261 63.8294 57.217C63.8294 56.5927 64.2939 55.9459 65.7409 55.9459C67.3406 55.9459 68.3795 56.4564 68.9372 56.721L69.595 54.1994C68.8162 53.8449 67.8256 53.503 66.3577 53.4553V51.4918H64.1787ZM101.99 53.0626C101.984 55.5918 93.8388 57.6718 83.7883 57.6718C82.7201 57.6718 81.6844 57.6576 80.6741 57.5994C80.8425 58.5095 80.9311 59.432 80.9311 60.3897C80.9311 60.7072 80.937 61.0023 80.9002 61.3198C81.9895 61.3621 82.9621 61.3714 83.7883 61.3714C88.3346 61.3714 97.0537 60.9857 101.99 58.2608V53.0626ZM101.99 58.9119C101.984 61.441 93.8388 63.521 83.7883 63.521C82.699 63.521 81.6439 63.4965 80.6125 63.4383C80.3756 64.7347 79.9522 65.9588 79.3997 67.107C81.0573 67.197 82.5726 67.2207 83.7883 67.2207C88.3346 67.2207 97.0537 66.835 101.99 64.11V58.9119ZM101.99 64.7818C101.984 67.3163 93.8388 69.3806 83.7883 69.3806C81.8361 69.3806 79.9546 69.3117 78.2075 69.1635C77.3288 70.4599 76.237 71.6109 75.0215 72.5739C78.3367 73.0025 81.5625 73.0906 83.7883 73.0906C88.3346 73.0906 97.0537 72.6996 101.99 69.98V64.7818Z",
    fill: "#FC3833"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddd_714_1119",
    x: 0,
    y: 0,
    width: 144.189,
    height: 157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_714_1119"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_714_1119",
    result: "effect2_dropShadow_714_1119"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_714_1119",
    result: "effect3_dropShadow_714_1119"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_714_1119",
    result: "effect4_dropShadow_714_1119"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_714_1119",
    result: "effect5_dropShadow_714_1119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_714_1119",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceTwo);
export default __webpack_public_path__ + "static/media/serviceTwo.ac7e18e8b09c6df53e91c87d8b2ab9f8.svg";
export { ForwardRef as ReactComponent };